// extracted by mini-css-extract-plugin
module.exports = {"themeSetting":"style_themeSetting__yphkW","title":"style_title__Oc_zY","tip":"style_tip__EytjV"};